import { render, staticRenderFns } from "./OrderCheckSetting.vue?vue&type=template&id=6c6c9de9&"
import script from "./OrderCheckSetting.vue?vue&type=script&lang=ts&"
export * from "./OrderCheckSetting.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCheckSetting.vue?vue&type=style&index=0&id=6c6c9de9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports